import { useContext, useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Box, Link } from "@mui/material";
import { GlobalContext } from "../../context/globalContext";
import { BusinessContext } from "../../context/businessContext";
import { Prefectures } from "../../assets/data/Constants";
import authorityUserType from "../../assets/data/TkAuthorityProperty";
import TkStepper from "../../components/atoms/TkStepper";
import TkContractorAndNumberLine from "../../components/molecules/TkContractorAndNumberLine";
import TkTable from "../../components/atoms/TkTable";
import TkBackButton from "../../components/molecules/TkBackButton";
import TkButton from "../../components/atoms/TkButton";
import { TkGetCode } from "../../utils/TkGetCode";
import { changeZipcodeFormat } from "../../utils/useTools";
import { httpAPI_PRE007 } from "./api/request";
import { headList, stepper } from "./parts";
import "./_style.scss";
import TkInfoManual from "../../components/atoms/TkInfoManual";
import { labelids } from "../../assets/data/TkExplanationProperty";

/**
 * SCRC080103 掛金納付対象職員届の提出確認
 * 掛金届提出前に登録されている情報を確認する。
 * @return SCRC080103
 */
const SCRC080103 = () => {
  const navigate = useNavigate();
  const { state, setState } = useContext(GlobalContext);
  const { state: businessState, setState: setBusinessState } =
    useContext(BusinessContext);
  const [bodyList, setBodyList] = useState<any>([]);
  const btnDisabledRef = useRef<boolean>(true);

  const handleCallApiInit = async () => {
    // 掛金納付対象職員作成参照API実行
    try {
      const res = await httpAPI_PRE007({
        contractorNo:
          state.authInfo?.userType === authorityUserType.userTypeNumber.KIKO
            ? businessState.common?.contractorNo!
            : state.authInfo?.contractorNo!,
      });
      if (res.resultCd === "I0000") {
        setState({
          ...state,
          errorMsgId: "",
        });
        btnDisabledRef.current = false;
        let bodyList = res.facilityList?.map((item) => [
          {
            children: (
              <Link
                onClick={() =>
                  handleLinkClick(item.facilityNo, item.facilityName)
                }
                data-testid="facilityLink"
              >
                {item.facilityNo}:{item.facilityName}
              </Link>
            ),
          },
          {
            children: item.requestDate,
          },
          {
            children: (
              <>
                {changeZipcodeFormat(item.zipcode || "")}
                <br />
                {TkGetCode(Prefectures, item.prefectureCd)}
                {item.addressCity}
                {item.addressOthers}
              </>
            ),
          },
          {
            children: item.facilityKind,
          },
          {
            children: item.facilityKbn,
          },
          {
            children:
              !item.specifiedStaffNum && !item.hcStaffNum
                ? "-"
                : (item.specifiedStaffNum ?? 0) + (item.hcStaffNum ?? 0) + "人", // 特定職員数等
          },
          {
            children: item.notJoinAfterChangeoverFlg,
          },
          {
            children: item.cancelKbn,
          },
          {
            children: (
              <>
                {res.managerName}
                <br />
                {res.tel}
                <br />
                {res.managerEmail}
              </>
            ),
          },
        ]);

        setBodyList(bodyList);
      } else {
        setState({
          ...state,
          errorMsgId: res.resultCd,
        });
        btnDisabledRef.current = true;
      }
    } catch (error) {
      navigate("/error");
    }
  };

  useEffect(() => {
    handleCallApiInit();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleLinkClick = (facilityNo: any, facilityName: any) => {
    // 持回り情報
    setBusinessState({
      common: businessState.common,
      job_11: {
        ...businessState.job_11,
        facilityNo: facilityNo,
        facilityName: facilityName,
      },
    });

    navigate("/SCRC080104");
  };

  return (
    <Box data-testid="SCRC080103test" className="SCRC080103">
      <TkStepper steps={stepper} activeStep={1} />

      <TkInfoManual rule={"\\n"} className="testForLarge">
        {labelids.labelid.LBLC080103_01}
      </TkInfoManual>
      {state.authInfo?.userType === authorityUserType.userTypeNumber.KIKO && (
        <TkContractorAndNumberLine
          name="契約者（法人）名"
          no={`${businessState.common?.contractorNo!}:${businessState.common
            ?.contractorName!}`}
        />
      )}

      <TkTable headList={headList} bodyList={bodyList} />

      <Box className="buttonGroup">
        <TkBackButton />
        <TkButton
          disabled={btnDisabledRef.current}
          onClick={() => navigate("/SCRC080006")}
        >
          納付する掛金を確認する
        </TkButton>
      </Box>
    </Box>
  );
};

export default SCRC080103;
